import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "payment-processing" }
const _hoisted_2 = { class: "processing" }
const _hoisted_3 = { class: "loading" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", null, "Payment in progress...", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_icon = _resolveComponent("loading-icon")!
  const _component_powered_by_footer = _resolveComponent("powered-by-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_loading_icon, {
          speed: 1000,
          mode: 'linear',
          color: '#ff5e00'
        })
      ]),
      _hoisted_4
    ]),
    _createVNode(_component_powered_by_footer)
  ]))
}